<template>
	<div class="mx-auto mt-8 w-full max-w-6xl rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
		<div class="text-center">
			<h3 class="text-sm sm:text-base font-semibold tracking-wide text-slate-700">
				Empowered by Leading Shipping Experts
			</h3>
			<p class="mt-2 text-2xl sm:text-3xl font-bold text-slate-900">
				Leading Brands We Work With
			</p>
		</div>

		<div class="mt-6 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-5">
			<div class="flex justify-center">
				<img class="h-10 w-auto object-contain sm:h-12" src="../assets/images/home/brands/brand1.svg" alt="brand1" />
			</div>
			<div class="flex justify-center">
				<img class="h-10 w-auto object-contain sm:h-12" src="../assets/images/home/brands/brand2.svg" alt="brand2" />
			</div>
			<div class="flex justify-center">
				<img class="h-10 w-auto object-contain sm:h-12" src="../assets/images/home/brands/brand3.png" alt="brand3" />
			</div>
			<div class="flex justify-center">
				<img class="h-10 w-auto object-contain sm:h-12" src="../assets/images/home/brands/brand3.svg" alt="brand4" />
			</div>
			<div class="flex justify-center">
				<img class="h-10 w-auto object-contain sm:h-12" src="../assets/images/home/brands/brand4.svg" alt="brand5" />
			</div>
		</div>
	</div>
</template>
